import Grid from 'material-ui/Grid'
import Typography from 'material-ui/Typography'
import * as React from 'react'
import { SFC } from 'react'
import { SpreadBody } from '../components/SpreadBody'

interface TeamMember {
    name: string
    role: string
    image: string
    linkedIn?: string
}

interface State {}

export class TeamSpread extends React.Component<{}, {}> {

    state: State = {}

    teamMembers: TeamMember[] = [
        {
            name: 'Trevor Dilley',
            role: 'Senior Developer',
            image: '/img/headshots/trevor.png'
        },
        {
            name: 'Keith Hamm',
            role: 'Server-Side Developer',
            image: '/img/headshots/keith.png'
        },
        {
            name: 'Josh Clark',
            role: 'Design Director',
            image: '/img/headshots/josh.png'
        },
        {
            name: 'Will Black',
            role: 'Senior Developer',
            image: '/img/headshots/will.png'
        },
        {
            name: 'Mike Biglan M.S.',
            role: 'CEO',
            image: '/img/headshots/mike.png'
        },
        {
            name: 'Nathan Westlake',
            role: 'Senior Developer',
            image: '/img/headshots/nathan.png'
        },
        {
            name: 'Cary Simons',
            role: 'Senior Developer',
            image: '/img/headshots/cary.png'
        },
        {
            name: 'Tiffany Kessler',
            role: 'Operations Coordinator',
            image: '/img/headshots/tiffany.png'
        },
        {
            name: 'Evey-Edward Neely',
            role: 'Developer',
            image: '/img/headshots/evey.png'
        },
        // {
        //     name: 'Whitney Davis',
        //     role: 'Senior Strategist',
        //     image: '/img/headshots/whitney.png'
        // },
        {
            name: 'James Madison',
            role: 'Senior UI/UX Designer',
            image: '/img/headshots/james.png'
        }
    ]

    TeamMemberCard: SFC<{ member: TeamMember }> = ({member}) => {
        return (
            <Grid item xs={12} sm={6} md={4} style={{textAlign: 'left'}}>
                <img
                    src={member.image}
                    alt={member.name}
                    style={{width: '100%'}}
                />
                <Typography
                    type='title'
                    color={'primary'}
                    style={{fontSize: '1em', lineHeight: '1.5em', fontWeight: 100}}
                >
                    {member.name}
                </Typography>
                <Typography type='subheading' style={{lineHeight: '.9em'}}>{member.role}</Typography>
            </Grid>
        )
    }

    render() {
        const {TeamMemberCard} = this
        return (
            <SpreadBody top={60}>
                <Grid container spacing={16}>
                    <Grid item xs={12}>
                        <Typography type='display1' style={{marginTop: 0}}>WHO WE ARE</Typography>
                        <Typography
                            type='subheading'
                            style={{
                                margin: '20px auto',
                                maxWidth: 650,
                                lineHeight: '2em',
                                letterSpacing: 1
                            }}
                        >
                            Twenty Ideas is a small, nimble team of creatives, engineers, and thought leaders who have
                            honed their crafts and are ready to transform industries, lives, and the world through
                            technology.
                            Oh, and we’re all just a little nerdy.
                        </Typography>
                    </Grid>
                    {this.teamMembers.map((m, i) => <TeamMemberCard key={i} member={m}/>)}
                </Grid>
            </SpreadBody>
        )
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/index/TeamSpread.tsx